// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"123":"43a23bd4","585":"5876b0aa"}[chunkId] + ".chunk.js");